import React from 'react';
import {withStyles} from '@material-ui/core';
import { compose } from 'recompose';

const styles = (theme) => ({
    containerBtn: {
        width: 112,
        height: 32,
        borderRadius: 4,
        boxShadow: '0 4px 12px 0 rgba(150, 49, 255, 0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
    },
    btnText: {
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#f8f5fe',
    }
})
const UpgradeButtonView = (props) => {
    const {classes, onClick, containerClasses, translations} = props

    return (
        <div data-intrcm-id="UpgradeBtn_5kpx9fte" onClick={onClick} className={[classes.containerBtn, containerClasses].join(" ")}>
            <div data-intrcm-id="UpgradeBtn_2rphpzzv" className={classes.btnText}>{translations.upgrade}</div>
        </div>
    )
}

export const UpgradeButton = compose(
    withStyles(styles, {withTheme: true}),
)(UpgradeButtonView)
